// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__OyZrv","content":"styles_content__c7oRM","skeleton":"styles_skeleton__IRzrV"};